export const validatePhone = (phone: string) => {
    if (phone.includes('_') || phone.length == 0) {
        return "Номер телефона введен не полностью";
    }
};

export const validateName = (name: string) => {
    if (name.length < 2) {
        return "Минимальный размер - 2 символа";
    }
};